import { defineNuxtPlugin } from "#app";
import FloatingVue, { vTooltip } from "floating-vue";
import "floating-vue/dist/style.css";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("tooltip", vTooltip);
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      tooltip: {
        $resetCss: true
      },
      "ds-light": {
        $extend: "tooltip",
        $resetCss: true
      },
      "ds-dark": {
        $extend: "tooltip",
        $resetCss: true
      }
    }
  });
});
